/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Kind_Meta_HintInputs */



/**
* | output |
* | --- |
* | "A meta-league groups child leagues. Add children after creation." |
*
* @param {League_Kind_Meta_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_kind_meta_hint = /** @type {((inputs?: League_Kind_Meta_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Kind_Meta_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une méta-ligue regroupe des ligues enfants. Ajoutez les enfants après la création.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una meta-liga agrupa ligas hijas. Añada las hijas después de la creación.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Uma meta-liga agrupa ligas filhas. Adicione as filhas após a criação.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un meta-campionato raggruppa campionati figli. Aggiungere i figli dopo la creazione.")
	return /** @type {LocalizedString} */ ("A meta-league groups child leagues. Add children after creation.")
});